export enum FormReportNavigation {
    Submissions = 'submissions',
    ActiveColleagues = 'active',
    InactiveColleagues = 'inactive',
    QuestionDetails = 'question',
    UserReport = 'userreport',
    UserDetails = 'userdetails',
}
